import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=49cdad9b"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=49cdad9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports